// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"70px","login":"styles_login__3uTQV","button":"styles_button__2FObp"};